

/** package import */

import React, { useState } from 'react'
import { GiHamburgerMenu } from "react-icons/gi";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { IoClose } from "react-icons/io5";

/** local file import */
import HeaderMenuOptions from './HeaderMenuOptions'
import Images from './Simage'
import { Link } from 'react-router-dom';




const HeaderNew = () => {

    const [menuShow, setMenuShow] = useState(false)

    const handleMenuShow = () => {
        setMenuShow(true)
    }

    const handleMenuHide = () => {
        setMenuShow(false)
    }

    return (
        <>
            <div className={`header-container ${menuShow ? "d-none" : "anim"}`}>
                <header className='aif-header'>
                    <Link to='/'>
                        <img src={Images.header_logo} className='aif-header__logo' />
                    </Link>

                    <div className='aif-header__right'>
                        <button
                            onClick={handleMenuShow}
                            className='d-xl-none aif-header__menu-button'>
                            <GiHamburgerMenu fontSize={25} />
                        </button>
                        <div className='d-none d-xl-block'>
                            <HeaderMenuOptions />
                        </div>
                    </div>
                </header >
            </div >


            {/* offcanvas - start */}

            <Offcanvas
                show={menuShow}
                onHide={handleMenuHide}
                placement="top"
                backdrop="static"
                className='aif-header__offcanvas'

            >
                <Offcanvas.Header >
                    <img src={Images.header_logo} className='aif-header__logo' />
                    <div className='aif-header__right'>
                        <button
                            onClick={handleMenuHide}
                            className='d-xl-none aif-header__menu-button'>
                            <IoClose fontSize={35} />
                        </button>
                        <div className='d-none d-xl-block'>
                            <HeaderMenuOptions />
                        </div>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className='aif-header__menu-offcanva'>
                        <HeaderMenuOptions />
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            {/* offcanvas - end */}
        </>
    )
}

export default HeaderNew